import { Component } from '@angular/core';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { ClickEventTags } from 'src/app/services/gtm/gtm-types';
import { WhatsAppMessage } from 'src/app/utils/constants';
import { buildWhatsAppUrl } from 'src/app/utils/utils';
import { vambeIA } from 'src/environments/environment.qa';

const { baseUrl, phoneNumber, clientId } = vambeIA;
@Component({
	selector: 'app-whatsapp-contact',
	templateUrl: './whatsapp-contact.component.html',
	styleUrls: ['./whatsapp-contact.component.scss'],
})
export class WhatsAppContactComponent {
	readonly whatsAppContactUrl = buildWhatsAppUrl(baseUrl, phoneNumber, clientId, WhatsAppMessage);

	constructor(private readonly gtmService: GtmService) {}

	onWhatsAppClick(): void {
		this.gtmService.handlerEvent(ClickEventTags.whatsappContact);
	}
}
